import { post, get, del, put } from './base';

const URL = '/membership';

export const PostMembershipAPI = (payload, config) =>
  post(`${URL}/`, payload, config);
export const GetMembershipAPI = config => get(`${URL}/`, config);
export const GetMembershipMembersAPI = config =>
  get(`${URL}/members/?page_size=1000`, config);
export const GetMembershipPrivateSpaceAPI = config =>
  get(`${URL}/spaces/`, config);

export const DeleteMembershipAPI = config => del(`${URL}/`, config);
export const DeleteMembershipMemberAPI = (id, config) =>
  del(`${URL}/members/${id}/`, config);
export const DeleteMembershipSpace = (id, config) =>
  del(`${URL}/spaces/${id}/`, config);

// Invitation
export const PostMemberInvitationAPI = (payload, config) =>
  post(`${URL}/invitations/`, payload, config);
export const DeleteMemberInvitationAPI = (id, config) =>
  del(`${URL}/invitations/${id}/`, config);
export const PutMembershipNumberAPI = (payload, config) =>
  put(`${URL}/numbers/`, payload, config);
export const GetInviteCodeAPI = id => get(`${URL}/invitations/${id}/`);
export const PutInvitationCompleteAPI = (id, config) =>
  put(`${URL}/invitations/${id}/`, {}, config);

// change payments
export const PutChangePaymentsAPI = config =>
  put(`${URL}/payment-method/`, {}, config);
